import React from 'react';

/**
 * 調度員狀態標誌組件
 * @param {Object} props
 * @param {string} props.status - 調度員狀態
 * @param {string} props.className - 額外的CSS類名
 */
const DispatcherStatusBadge = ({ status, className = '' }) => {
    const getStatusConfig = () => {
        switch (status) {
            case 'active':
                return {
                    label: '在職',
                    bgColor: 'bg-green-100',
                    textColor: 'text-green-600',
                    dotColor: 'bg-green-500'
                };
            case 'inactive':
                return {
                    label: '停職',
                    bgColor: 'bg-gray-100',
                    textColor: 'text-gray-600',
                    dotColor: 'bg-gray-500'
                };
            case 'suspended':
                return {
                    label: '暫停',
                    bgColor: 'bg-red-100',
                    textColor: 'text-red-600',
                    dotColor: 'bg-red-500'
                };
            case 'on_leave':
                return {
                    label: '請假中',
                    bgColor: 'bg-yellow-100',
                    textColor: 'text-yellow-600',
                    dotColor: 'bg-yellow-500'
                };
            default:
                return {
                    label: status,
                    bgColor: 'bg-gray-100',
                    textColor: 'text-gray-600',
                    dotColor: 'bg-gray-500'
                };
        }
    };

    const { label, bgColor, textColor, dotColor } = getStatusConfig();

    return (
        <div className={`flex items-center ${className}`}>
            <div className={`w-2 h-2 rounded-full ${dotColor} mr-2`}></div>
            <span className={`px-2 py-1 rounded-full text-xs ${bgColor} ${textColor}`}>
                {label}
            </span>
        </div>
    );
};

export default DispatcherStatusBadge;